// Tipos de Provedor
export enum TipoProvedor {
  BASEDADOS = 'BASEDADOS',
  APIREST = 'APIREST'
}

// Tipos de Credencial
export enum TipoCredencial {
  SEM_CREDENCIAL = 'SEM_CREDENCIAL',
  BASIC = 'BASIC',
  BEARER = 'BEARER',
  API_KEY = 'API_KEY',
  OAUTH2 = 'OAUTH2',
  DATABASE = 'DATABASE'
}

// Métodos HTTP
export enum MetodoHttp {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

// Tipos de API
export enum TipoApi {
  JSON = 'JSON',
  XML = 'XML',
  SOAP = 'SOAP',
  TEXT = 'TEXT',
  UNKNOWN = 'UNKNOWN'
}

// Tipos de Recurso
export enum TipoRecurso {
  IMPORTACAO = 'IMPORTACAO',
  PROCESSAMENTO = 'PROCESSAMENTO',
  VISUALIZACAO = 'VISUALIZACAO',
  EXPORTACAO = 'EXPORTACAO',
  PUBLICACAO = 'PUBLICACAO'
}

// Tipos de Comando
export enum TipoComando {
  DATABASE_SQL = 'DATABASE_SQL',
  API_ENDPOINT = 'API_ENDPOINT'
}

// Direção de Publicação
export enum DirecaoPublicacao {
  OUTBOUND = 'OUTBOUND',
  INBOUND = 'INBOUND',
  BIDIRECIONAL = 'BIDIRECIONAL'
}

// Fonte de Dados Publicação
export enum FonteDadosPublicacao {
  REGISTROS_BRUTOS = 'REGISTROS_BRUTOS',
  REGISTROS_TRANSFORMADOS = 'REGISTROS_TRANSFORMADOS',
  REGISTROS_VISUALIZACAO = 'REGISTROS_VISUALIZACAO'
}

// Destino Recebimento
export enum DestinoRecebimento {
  BANCO_DADOS = 'BANCO_DADOS',
  API_EXTERNA = 'API_EXTERNA',
  FILA_PROCESSAMENTO = 'FILA_PROCESSAMENTO'
}

// Modo Processamento
export enum ModoProcessamento {
  SINCRONO = 'SINCRONO',
  ASSINCRONO = 'ASSINCRONO'
}

// Formato Resposta
export enum FormatoResposta {
  JSON = 'JSON'
}

// Status do Recebimento de Registro
export enum StatusRecebimentoRegistro {
  PENDENTE = 'PENDENTE',
  PROCESSANDO = 'PROCESSANDO',
  CONCLUIDO = 'CONCLUIDO',
  ERRO = 'ERRO'
}

// Status da Integração do Registro (Visualização)
export enum StatusIntegracaoRegistro {
  PENDENTE = 'PENDENTE',
  INTEGRADO = 'INTEGRADO',
  ERRO = 'ERRO'
}

